class DashboardService {
  constructor($http, $rootScope) {
    "ngInject";
    this.name = 'DashboardService';
    this.$http = $http;
    this.baseUrl = $rootScope.apiHost +'/api/admin/dashboard';

  }

  getDashboardInformation() {
    return this.$http.get(this.baseUrl, {withCredentials: true});
  }


}

export default DashboardService;



// WEBPACK FOOTER //
// ./client/common/services/dashboard/dashboard.service.js